import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoLogoDiscord } from 'react-icons/io5';
import env from "../../data/env";
import Button from '../button/Button';
import dispatchEvent from "../../fns/common/dispatchEvent";
import dispatchPixelEvent from "../../fns/common/dispatchPixelEvent";
import { useChain, useFanEpackClaims, useWallet } from "../../hooks/useEventStates";
import { wei } from "../../utils/units";

import epack from '../../assets/images/epack-banner.gif';

const ThankYou = () => {
    const wallet = useWallet();
    const chain = useChain();
    const claims = useFanEpackClaims();
    const navigate = useNavigate();
    const [nftUri, setNftUri] = useState("");

    useEffect(() => {
        function redirectHome() {
            navigate("/");
        }
    
        if (!wallet) {
            redirectHome();
            return;
        }
    
        const baseURL = `https://eth-${chain === 1 ? "mainnet" : "rinkeby"}.alchemyapi.io/v2/${env.alchemyKey}/getNFTs/`;
        const fetchURL = `${baseURL}?owner=${wallet}&contractAddresses[]=${env.metafansAddress}&withMetadata=false`;
    
        fetch(fetchURL, {
          method: "GET",
          redirect: "follow",
        })
          .then(response => response.json())
          .then(response => JSON.stringify(response, null, 2))
          .then(result => {
            const res = JSON.parse(result);
    
            if (!res.ownedNfts?.length) {
              redirectHome();
              return;
            }
    
            const tokenId = Math.max(...res.ownedNfts.map((/** @type {any} */ item) => wei(item.id.tokenId).toNumber()));
            setNftUri(`${env.baseUri}/${tokenId}.png`);
          })
          .catch(error => console.error("error", error));
      }, [chain, navigate, wallet]);

    return (
        <section className="thank-you">
            <div className="py-12">
                <div className="container mx-auto">
                    <h1 className="lt-white font-bold text-center">Welcome to the MetaFam!</h1>
                    <p className="text-xl text-grey text-center font-semibold mt-5 px-60">
                        We’re excited you’re here! Did you know being a MetaFans NFT holder comes with many IRL and online benefits?
                        Join our Discord server to access the community chat, giveaways, and more! Also be sure to share your
                        newly minted MetaFan on our #main-chat channel and say hi! If you are not on Discord join our newsletter
                        so you don’t miss important updates.
                    </p>
                    {nftUri && (
                        <div className="w-[30rem] mx-auto mt-10">
                            <img 
                                className="w-full"
                                src={nftUri} 
                                alt="MetaFan"
                            />
                        </div>
                    )}
                    <div className="w-[15rem] flex justify-center mx-auto mt-10">
                        <Button
                            isLink
                            variant="Outline"
                            className="w-full flex justify-center"
                            href="/affiliate"
                        >
                            Refer A Friend
                        </Button>
                    </div>
                    <div className="w-[15rem] flex justify-center mx-auto mt-5">
                        <Button
                            isLink
                            variant="Primary"
                            className="w-full flex items-center justify-center"
                            href="https://discord.gg/5RrNCnvRny"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <IoLogoDiscord className="text-xl mr-2" />
                            Join our discord
                        </Button>
                    </div>
                </div>
            </div>
            <div className="bg-[#22252D] py-12">
                <div className="container mx-auto">
                    <p className="text-xl text-grey text-center font-semibold px-40">
                        Want to sign up for our newsletter to get information on the latest events and news?<br />Enter your email below to be put on the MetaFans newsletter!
                    </p>
                    <div className="home-signup text-hidden mt-10">
                        <div className="signup-box p-0">
                            <div className="klaviyo-form-T24r2w" id="email-signup"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="py-12">
                <div className="container mx-auto">
                    <h1 className="text-5xl text-white font-bold text-center">Claim your FREE FanEpack today!</h1>
                    <p className="text-xl text-grey text-center font-semibold mt-5 px-60">
                        You are entitled to a FREE FanEpack NFT with each MetaFan you mint. Holding a FanEpack in your wallet gets you increased rewards for squares, pickems and other weekly games + more coming soon!
                    </p>
                    <div className="w-full rounded-[32px] overflow-hidden mt-16">
                        <img className="w-full h-[380px] object-cover" src={epack} alt="FanEpacks"></img>
                    </div>
                    <div className="text-center mt-16">
                        <Button
                            variant="Primary"
                            onClick={() => dispatchEvent("fanEpackModalRequested")}
                        >
                            Claim Your FanEpack
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ThankYou;